export default {
  sm: `
  Data is used in different industries including education, medicine, finance, and public sectors to create new values. Crude oil powered industrial sites in the early 20th century. The role is now taken over by data.
  `
};
